
export const CustomCheckBoxSize = {
    DEFAULT: 'default',
    LITTLE: 'little',
}


// WEBPACK FOOTER //
// ./web/js/components/customCheckbox/constants.js